import { useEffect, useState } from 'react'
import { CROP_WIDTH, CROP_HEIGHT } from '../_shared/ImageConstant'
import { useArticleContext } from '../_core'
import { getImage } from '@app-core/api'
import isEmpty from 'lodash/isEmpty'

export const useInitializeSelectedImages = () => {
  const { articleState } = useArticleContext()
  const [selectedImages, setSelectedImages] = useState([])

  const initializeSelectedImagesFromArticleState = async () => {
    const imageIds = articleState.imageIds
    if (imageIds.length > 0 && selectedImages.length === 0) {
      for (const i in imageIds) {
        const id = imageIds[i]
        const response = await getImage({ id })
        if (response.data) {
          const image = {
            ...response.data,
            upload: {
              success: true,
              errorCodes: [],
            },
            isCover: true, // 目前只能上傳一張圖片
          }
          const crop = image.crop
          if (!isEmpty(crop)) {
            // image.crop 是 getImage 回傳的圖片裁切資訊
            // 如果圖片曾經被使用者裁切過，需要以下步驟還原圖片正確的位置

            const originalWidth = response.data.originalSize.width
            const originalHeight = response.data.originalSize.height

            // cropHeight, cropWidth 為裁切框框的長寬，會因為目前的裁切比例而不同
            const cropHeight = CROP_HEIGHT
            const cropWidth = CROP_WIDTH

            // let direction = null
            // bgImageWidth, bgImageHeight為圖片在裁切 lightbox 裡背景底層的長寬，需根據圖片的方向計算
            let bgImageWidth
            let bgImageHeight

            // 四捨五入到小數第二位
            const roundedRatio = (ratio) => Math.round((ratio + Number.EPSILON) * 100) / 100
            const originalImageRatio = roundedRatio(originalHeight / originalWidth)
            const cropRatio = roundedRatio(cropHeight / cropWidth)
            if (originalWidth === originalHeight) {
              // direction = 'square'
              bgImageWidth = cropHeight
              bgImageHeight = cropHeight
            } else if (originalImageRatio <= cropRatio) {
              // direction = 'horizontal'
              bgImageWidth = originalWidth * (cropHeight / originalHeight)
              bgImageHeight = cropHeight
            } else {
              // direction = 'vertical'
              bgImageWidth = cropWidth
              bgImageHeight = originalHeight * (cropWidth / originalWidth)
            }

            // croppedBgPositionX, croppedBgPositionY 為圖片在裁切 lightbox 裡裁切層的位置
            // bgLeft, bgTop 為圖片在裁切 lightbox 裡背景底層的位置
            // 以上都需要用裁切座標來還原，並存在 cropPosition 裏
            const croppedBgPositionX = crop.x ? -((crop.x * bgImageWidth) / originalWidth) : 0
            const croppedBgPositionY = crop.y ? -((crop.y * bgImageHeight) / originalHeight) : 0
            const bgLeft =
              crop.x >= 0
                ? (bgImageWidth - cropWidth) / 2 - (crop.x * bgImageWidth) / originalWidth
                : 0
            const bgTop =
              crop.y >= 0
                ? (bgImageHeight - cropHeight) / 2 - (crop.y * bgImageHeight) / originalHeight
                : 0

            // 設定cropPosition
            const cropPosition = {
              croppedBgPositionX,
              croppedBgPositionY,
              bgLeft,
              bgTop,
            }
            image.cropPosition = cropPosition
          }

          setSelectedImages([image])
        }
      }
    }
  }

  useEffect(() => {
    initializeSelectedImagesFromArticleState()
  }, [articleState.imageIds, articleState.coverImageId, selectedImages.length, selectedImages])

  return { selectedImages, setSelectedImages }
}
